/**
 * Created by Dustin on 10.5.2018.
 */
import { connect } from 'react-redux';
import * as changePasswordActions from '../actions/ChangePasswordActions.js';
import {ChangePasswordWnd} from '../components/ChangePasswordWnd.jsx';

const mapStateToProps = state => {
    return {
        show: state.changePassword.show,
        error: state.changePassword.error,
        username: state.changePassword.username,
        password: state.changePassword.password,
        retypedPassword: state.changePassword.retypedPassword,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onHide: () => {
            dispatch(changePasswordActions.showChangePasswordWnd(false));
            dispatch(changePasswordActions.clearChangePasswordData());
        },
        onSave: () => {dispatch(changePasswordActions.changePassword())},
        onUserDataChanged: (field, value) => {dispatch(changePasswordActions.updateChangePasswordData(field, value))}
    }
};

const ChangePasswordWndController = connect(
    mapStateToProps,
    mapDispatchToProps
)(ChangePasswordWnd);

export default ChangePasswordWndController;
